import $ from 'jQuery';
global.$ = global.jQuery = $;
import Cookies from 'js-cookie';
import Swiper, { Navigation, Pagination, Autoplay } from 'Swiper';

global.isDebug = true;
global.__c__ = function(a){
  if(isDebug){
    console.log(a);
  }
}

var __name__ = "Q2n64yM8";
var SetCookieValue = function(){
  Cookies.set(__name__, "omission", { expires : 60, path: "/" });
};

var IsSetCookie = function(){
  if(Cookies.get(__name__) === "omission"){
    return true;
  }
  return false;
};

var _hash = window.location.hash;
if(_hash === "#clear"){
  Cookies.remove(__name__, { path: "" });
}

var pow = Math.pow,
  sqrt = Math.sqrt,
  sin = Math.sin,
  cos = Math.cos,
  PI = Math.PI,
  c1 = 1.70158,
  c2 = c1 * 1.525,
  c3 = c1 + 1,
  c4 = ( 2 * PI ) / 3,
  c5 = ( 2 * PI ) / 4.5;
// x is the fraction of animation progress, in the range 0..1
function bounceOut(x) {
  var n1 = 7.5625,
    d1 = 2.75;
  if ( x < 1/d1 ) {
    return n1*x*x;
  } else if ( x < 2/d1 ) {
    return n1*(x-=(1.5/d1))*x + 0.75;
  } else if ( x < 2.5/d1 ) {
    return n1*(x-=(2.25/d1))*x + 0.9375;
  } else {
    return n1*(x-=(2.625/d1))*x + 0.984375;
  }
}
$.extend( $.easing,
  {
    def: 'easeOutQuad',
    swing: function (x) {
      return $.easing[$.easing.def](x);
    },
    easeInQuad: function (x) {
      return x * x;
    },
    easeOutQuad: function (x) {
      return 1 - ( 1 - x ) * ( 1 - x );
    },
    easeInOutQuad: function (x) {
      return x < 0.5 ?
        2 * x * x :
        1 - pow( -2 * x + 2, 2 ) / 2;
    },
    easeInCubic: function (x) {
      return x * x * x;
    },
    easeOutCubic: function (x) {
      return 1 - pow( 1 - x, 3 );
    },
    easeInOutCubic: function (x) {
      return x < 0.5 ?
        4 * x * x * x :
        1 - pow( -2 * x + 2, 3 ) / 2;
    },
    easeInQuart: function (x) {
      return x * x * x * x;
    },
    easeOutQuart: function (x) {
      return 1 - pow( 1 - x, 4 );
    },
    easeInOutQuart: function (x) {
      return x < 0.5 ?
        8 * x * x * x * x :
        1 - pow( -2 * x + 2, 4 ) / 2;
    },
    easeInQuint: function (x) {
      return x * x * x * x * x;
    },
    easeOutQuint: function (x) {
      return 1 - pow( 1 - x, 5 );
    },
    easeInOutQuint: function (x) {
      return x < 0.5 ?
        16 * x * x * x * x * x :
        1 - pow( -2 * x + 2, 5 ) / 2;
    },
    easeInSine: function (x) {
      return 1 - cos( x * PI/2 );
    },
    easeOutSine: function (x) {
      return sin( x * PI/2 );
    },
    easeInOutSine: function (x) {
      return -( cos( PI * x ) - 1 ) / 2;
    },
    easeInExpo: function (x) {
      return x === 0 ? 0 : pow( 2, 10 * x - 10 );
    },
    easeOutExpo: function (x) {
      return x === 1 ? 1 : 1 - pow( 2, -10 * x );
    },
    easeInOutExpo: function (x) {
      return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ?
        pow( 2, 20 * x - 10 ) / 2 :
        ( 2 - pow( 2, -20 * x + 10 ) ) / 2;
    },
    easeInCirc: function (x) {
      return 1 - sqrt( 1 - pow( x, 2 ) );
    },
    easeOutCirc: function (x) {
      return sqrt( 1 - pow( x - 1, 2 ) );
    },
    easeInOutCirc: function (x) {
      return x < 0.5 ?
        ( 1 - sqrt( 1 - pow( 2 * x, 2 ) ) ) / 2 :
        ( sqrt( 1 - pow( -2 * x + 2, 2 ) ) + 1 ) / 2;
    },
    easeInElastic: function (x) {
      return x === 0 ? 0 : x === 1 ? 1 :
        -pow( 2, 10 * x - 10 ) * sin( ( x * 10 - 10.75 ) * c4 );
    },
    easeOutElastic: function (x) {
      return x === 0 ? 0 : x === 1 ? 1 :
        pow( 2, -10 * x ) * sin( ( x * 10 - 0.75 ) * c4 ) + 1;
    },
    easeInOutElastic: function (x) {
      return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ?
        -( pow( 2, 20 * x - 10 ) * sin( ( 20 * x - 11.125 ) * c5 )) / 2 :
        pow( 2, -20 * x + 10 ) * sin( ( 20 * x - 11.125 ) * c5 ) / 2 + 1;
    },
    easeInBack: function (x) {
      return c3 * x * x * x - c1 * x * x;
    },
    easeOutBack: function (x) {
      return 1 + c3 * pow( x - 1, 3 ) + c1 * pow( x - 1, 2 );
    },
    easeInOutBack: function (x) {
      return x < 0.5 ?
        ( pow( 2 * x, 2 ) * ( ( c2 + 1 ) * 2 * x - c2 ) ) / 2 :
        ( pow( 2 * x - 2, 2 ) *( ( c2 + 1 ) * ( x * 2 - 2 ) + c2 ) + 2 ) / 2;
    },
    easeInBounce: function (x) {
      return 1 - bounceOut( 1 - x );
    },
    easeOutBounce: bounceOut,
    easeInOutBounce: function (x) {
      return x < 0.5 ?
        ( 1 - bounceOut( 1 - 2 * x ) ) / 2 :
        ( 1 + bounceOut( 2 * x - 1 ) ) / 2;
    }
  });

global._isSP = undefined;

if(window.outerWidth < 829){
  _isSP = true;
}else{
  _isSP = false;
}

class SwitchImage{
  constructor($target){
    this.duration = $target.data("switch-duration") ? $target.data("switch-duration") | 0 : 3000;
    this.timer = null;
    this.images = $target.find("img");
    this.max = this.images.length;
    this.count = 0;
    this.name = (function(){
      var __class = $target.attr("class");
      return __class;
    })();
  }
  start(){
    var _this = this;
    _this.change();
    _this.timer = setInterval(function(){
      _this.change();
    }, _this.duration);
  }
  stop(){
    var _this = this;
    clearInterval(_this.timer);
  }
  change(){
    var _this = this;
    _this.images.each(function(i){
      if(i === _this.count){
        $(_this.images[i]).css({display: "block"});
      }else{
        $(_this.images[i]).css({display: "none"});
      }
    });
    _this.count++;
    _this.count = _this.count % _this.max;
  }
  setDuration(duration){
    var _this = this;
    _this.duration = duration;
  }
}


var Init = function(){
  var $window = $(window);
  var $body = $("body");
  var $confirmation = $("#confirmation");
  var $first = $("#first");

  var AnimationStart = function($container){
    // console.log("AnimationStart");
    var _$wait = $container.find(".wait");
    _$wait.each(function(){
      var __$this = $(this);
      var __delay = __$this.data("delay");
      var __timeout = setTimeout(function(){
        __$this
          .removeClass("wait")
          .addClass("animation");
        clearTimeout(__timeout);
      }, __delay)
    });
  };

  var ResetAnimate = function($container){
    // console.log("ResetAnimate");
    var _$animate = $container.find(".animation");
    var _$animating = $container.find(".animating");
    _$animate.each(function(){
      var __$this = $(this);
      __$this
        .addClass("wait")
        .removeClass("animation");
    });
    _$animating.each(function(){
      var __$this = $(this);
      __$this
        .addClass("waiting")
        .removeClass("animating");
    });

  };

  var SetAnimation = function(){
    var $section = $(".waiting");
    var sectionLen = $section.length;
    var timing, _height, mainHeight, mainTop;
    _height = $window.height();
    mainTop = 0;
    timing = _height - (_height / 5);

    for(var i = 0; i < sectionLen; i++){
      var $wait = $($section[i]);
      var offsetTop;
      offsetTop = $wait.offset().top;

      if($window.scrollTop() + timing >= offsetTop && $window.scrollTop() <= offsetTop){
        var _delay = $wait.data("delay");
        if(_delay === void 0){
          _delay = 0;
        }
        $wait.delay(_delay).queue(function(){
          var __$this = $(this);
          __$this.removeClass("waiting").addClass('animating');
          __$this.dequeue();
        });
      }
    }
    if(sectionLen === 0){
      $window.off("scroll", AnimationScroller);
    }
  };

  var AnimationScroller = function(){};


  // のれん
  var StartNoren = function(event){
    if($window.scrollTop() + 1 >= $first.height()){
      StartTopAnimation();
      $window.off("scroll", StartNoren);
    }
  };

  // のれんのアニメーション
  var NorenAnimate = function(){
    $first.addClass("animate");
    var _timer = setTimeout(function(){
      $(".view_area").addClass("noren-animation").removeClass("now-animation");
      $body.removeClass("is-modal");
      $confirmation.remove();
      $window.on("scroll", StartNoren);
      clearTimeout(_timer);
    }, 2000);
  };

  // 初期で OVERFLOW HIDDEN 使うのでスクロール位置を一番上にしてから、もろもろスタートさせる
  var _initPos = setTimeout(function(){
    window.scrollTo(0, 0);

    // 年齢確認
    if(!IsSetCookie()){
      $confirmation.animate({opacity: 1}, 300);
      $body.addClass("is-modal");
      var $yes = $("#yes");
      var $omission = $("#omission");
      var YesClicked = function(){
        $confirmation.stop().animate({opacity: 0}, 300);
        $first.stop().animate({opacity: 1}, 300, NorenAnimate);
        if( $omission.prop("checked") ){
          SetCookieValue();
        }
      };
      $yes.on("click", YesClicked);
    }else{
      $first.stop().animate({opacity: 1}, 300, NorenAnimate);
    }

    clearTimeout(_initPos);
  }, 100);

  // 切り替えアニメーション
  var $switch = $(".switch");
  $switch.each(function(){
    var _s = new SwitchImage($(this));
    var _delay = $(this).data("switch-delay") ? $(this).data("switch-delay") | 0 : 0;
    var _timer = setTimeout(function(){
      _s.start();
      clearTimeout(_timer);
    }, _delay);
  });

  // メインのアニメーション
  var StartTopAnimation = function(){
    $first.remove();
    window.scrollTo(0, 0);
    $(".view_area").removeClass("noren-animation").addClass("now-animation");
    document.getElementById('top').classList.add('animate');
    var _t = setTimeout(function(){
      $(".left-content").removeClass("wait-init");
      $(".view_area").removeClass("now-animation");
      $(".second-container").css({opacity: 0}).animate({opacity: 1}, 300);

      // Slider
      /*var $tashinamuSlides = null;
      var tashinamuSlider = new Swiper(".tashinamu-slider", {
        modules: [Autoplay],
        loop: true,
        loopAdditionalSlides: 1,
        speed: 1000,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        on: {
          slideNextTransitionStart : function(){
            if($tashinamuSlides === null){
              $tashinamuSlides = $(".tashinamu-slider").find(".swiper-slide");
            }
            $tashinamuSlides.removeClass("stopped").addClass("moving");
          },
          slideNextTransitionEnd : function(){
            if($tashinamuSlides === null){
              $tashinamuSlides = $(".tashinamu-slider").find(".swiper-slide");
            }
            $tashinamuSlides.removeClass("moving").addClass("stopped");
          },
        }
      });*/

      var $popSlides = null;
      var popSlider = new Swiper(".pop-slider", {
        modules: [Navigation, Pagination, Autoplay],
        loop: true,
        loopAdditionalSlides: 1,
        speed: 1000,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        on: {
          slideNextTransitionStart : function(){
            if($popSlides === null){
              $popSlides = $(".pop-slider").find(".swiper-slide");
            }
            $popSlides.removeClass("stopped").addClass("moving");
          },
          slideNextTransitionEnd : function(){
            if($popSlides === null){
              $popSlides = $(".pop-slider").find(".swiper-slide");
            }
            $popSlides.removeClass("moving").addClass("stopped");
          },
          afterInit : function(){
            var _len = $(".pop-slider").find(".swiper-slide").not(".swiper-slide-duplicate").length;
            $(".swiper-pagination").find(".swiper-pagination-bullet").addClass("count" + _len);
          }
        },
        pagination: {
          el: '.pop-slider-pagination',
        },
        navigation: {
          nextEl: '.pop-slider-next',
          prevEl: '.pop-slider-prev',
        }
      });


      // ScrollAnimatiopn
      AnimationScroller = function(){
        SetAnimation();
      };

      $window.on("scroll", AnimationScroller);
      AnimationScroller();

      clearTimeout(_t);
    }, 1500);
  };

  // 参加酒造アコーディオン
  var $shop = $("#shop");
  var Accordion = function(){
    if($shop.hasClass("open")){
      $shop.removeClass("open");
      $(".shop-inner").stop().slideUp(300);
    }else{
      $shop.addClass("open");
      $(".shop-inner").stop().slideDown(300);
    }
  };
  $(".shop-tap").on("click", Accordion);

  $(".pagetop").on("click", function(){
    $("html, body").stop().animate({scrollTop: 0}, 1000, "easeInOutCirc");
  });

  $(".anchor").on("click", function(){
    var _$this = $(this);
    var _$target = $(_$this.attr("href"));
    $("html, body").stop().animate({scrollTop: _$target.offset().top}, 1000, "easeInOutCirc");
    return false;
  });

  var Resize = function(){
    if($window.width() < 829){
      _isSP = true;
    }else{
      _isSP = false;
    }
  };
  $window.on("resize", Resize);
  Resize();

};

window.addEventListener("load", Init);


// YOUTUBE
var tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var player;
global.onYouTubeIframeAPIReady = function() {
  player = new YT.Player('youtube', {
    height: '360',
    width: '640',
    videoId: 'Ei5mEfBCMm4',
    events: {
      'onReady': onPlayerReady,
      'onStateChange': onPlayerStateChange
    }
  });
};

var movie = document.getElementById("movie");
global.onPlayerReady = function(event) {
  //alert("ready!");
  //event.target.playVideo();
  movie.addEventListener('click', VideoOnOff);
}

var VideoOnOff = function(){
  if(player.getPlayerState() === 1){
    //movie.style.display = '';
    player.pauseVideo();
  } else if(player.getPlayerState() === 0 || player.getPlayerState() === 2 || player.getPlayerState() === 5){
    movie.style.display = 'none';
    player.playVideo();
  }
}

/*
* YT.PlayerState.PAUSED
* YT.PlayerState.ENDED
* YT.PlayerState.PLAYING
* */

global.onPlayerStateChange = function(event) {
  if (event.data == YT.PlayerState.ENDED) {
    // end
    player.seekTo(0);
    player.pauseVideo();
  } else if(event.data == YT.PlayerState.PAUSED) {
    // pause
    //movie.style.display = "";
  } else if(event.data == YT.PlayerState.PLAYING) {
    // playing
    //movie.style.display = "none";
  }
}
